export const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = (error) => reject(error);
});

export const generateId = () => Math.random().toString(36).substr(2, 9);

// Generate a proper UUID v4 for Supabase compatibility
export const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

export const formatNumber = (num, decimals = 0) => {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(num);
};

export const formatTime = (date) => {
    return new Date(date).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
};

export const getTimeOfDay = () => {
    const hour = new Date().getHours();
    if (hour < 6) return 'Night';
    if (hour < 12) return 'Morning';
    if (hour < 17) return 'Afternoon';
    if (hour < 21) return 'Evening';
    return 'Night';
};

export const getMealType = () => {
    const hour = new Date().getHours();
    if (hour < 10) return 'Breakfast';
    if (hour < 14) return 'Lunch';
    if (hour < 17) return 'Snack';
    return 'Dinner';
};

export const getRandomTip = (tips) => tips[Math.floor(Math.random() * tips.length)];

// Scientific Calorie Calculations - Using comprehensive MET database
// Re-export from exerciseCalculator for backward compatibility

import {
    calculateExerciseCaloriesScientific as _calcExercise,
    calculateStepsCaloriesScientific as _calcSteps,
    quickCalorieCalc,
    MET_DATABASE
} from './exerciseCalculator';

// Backward compatible wrapper for existing code
export const calculateExerciseCalories = (type, durationMinutes, intensity, userWeightKg, userAge = 30, userGender = 'Female') => {
    // Map old intensity values to new format
    const intensityMap = { 'Low': 'light', 'Moderate': 'moderate', 'High': 'vigorous' };
    const newIntensity = intensityMap[intensity] || 'moderate';

    // Map common exercise names to category/variation
    const exerciseMap = {
        'Walking': { category: 'walking', variation: 'moderate' },
        'Running': { category: 'running', variation: 'run_6mph' },
        'Cycling': { category: 'cycling', variation: 'moderate' },
        'Swimming': { category: 'swimming', variation: 'lap_swimming' },
        'Yoga': { category: 'yoga', variation: 'vinyasa' },
        'HIIT': { category: 'hiit', variation: 'intermediate' },
        'Strength Training': { category: 'strength', variation: 'moderate' }
    };

    const mapping = exerciseMap[type];
    if (mapping) {
        const result = _calcExercise({
            category: mapping.category,
            variation: mapping.variation,
            durationMinutes,
            weight: userWeightKg,
            age: userAge,
            gender: userGender,
            fitnessLevel: 'Intermediate'
        });
        return result.calories;
    }

    // Fallback for unmapped exercises: use generic MET
    const genericMET = { 'Low': 3.0, 'Moderate': 5.0, 'High': 7.0 };
    const met = genericMET[intensity] || 5.0;
    return Math.round(met * userWeightKg * (durationMinutes / 60));
};

export const calculateStepsCalories = (steps, userWeightKg, userAge = 30, userGender = 'Female') => {
    return _calcSteps(steps, userWeightKg, userAge, userGender);
};

// Export scientific functions for advanced usage
export { MET_DATABASE, quickCalorieCalc };
